module.exports = __webpack_public_path__ + "media/images/flags/1x1/tgo-e158cb5da131675033ca05ca061582f7.svg";